import React, { Component } from "react";

export class AddressModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.AddressModal = this;
  }
  render() {
    let { props } = this;
    let { id, title, show, onClose, modalSize, errorMessage } = props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose"]);

    return (
      <AppCanvas
        id={id}
        title={title}
        show={show}
        onClose={onClose}
        modalSize={modalSize}
      >
        <AppFormData
          {...attrs}
          onClose={onClose}
          errorMessage={errorMessage}
        ></AppFormData>
      </AppCanvas>
    );
  }
}

export default AddressModal;
